import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type GetPatientElectronicPrescriptionMedicationParams =
	InsuredPatientCommandParams /* & {}*/;

export const GetPatientElectronicPrescriptionMedication = (
	params: GetPatientElectronicPrescriptionMedicationParams,
): Command => {
	return {
		operation: 'DajLiekovuKartu',
		params,
	};
};
